import React from 'react';
import {
    MimaButton,
    MimaText,
    MimaToastUtil,
    Modal,
    MimaInput,
    MimaDropdown
} from '../../components';
import { Formik } from 'formik';
import { PermissionListContainer } from '../../containers';

const EditAdmin = ({closeModal, data}) => {

    return (
        <Modal closeModal={closeModal}>        
           
                <PermissionListContainer
                data={data}
                closeModal={closeModal}
                />   

        </Modal>
    )
}

export default EditAdmin;